<template>
  <div class="prelogin-layout min-h-screen bg-[#FCFCFC] flex flex-col">
    <div class="flex-1 flex items-center justify-center px-4">
      <div class="w-full max-w-[380px]">
        <div class="flex justify-center mb-8">
          <brand-logo />
        </div>
        <slot />
      </div>
    </div>
    <div class="px-8 pb-6 pt-4">
      <div class="flex items-center justify-between">
        <p class="text-xs text-neutral-500 font-normal">
          © {{ currentYear }} Countly. All rights reserved.
        </p>
        <div class="flex items-center gap-6">
          <a
            href="https://countly.com/legal/privacy-policy"
            target="_blank"
            class="text-xs text-neutral-500 font-normal hover:text-neutral-900 transition-colors"
          >
            Privacy policy
          </a>
          <a
            href="https://countly.com/legal/terms-of-service"
            target="_blank"
            class="text-xs text-neutral-500 font-normal hover:text-neutral-900 transition-colors"
          >
            Terms of service
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BrandLogo from './containers/brand-logo.vue';

export default {
  name: 'WelcomeLayout',
  components: {
    BrandLogo,
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>
